module.exports = __webpack_public_path__ + "fonts/lacuna.ab6df3f7.ttf";